import React, { useContext, useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { DraggableModalDialog } from '../../Dialogs/DraggableModalDialog';
import PrivilegesContext from '../../Contexts/PrivilegesContext';

function CommonConfigDialog({ children, title, dialogData, showDialog, closeDialog, save, fieldErrors, setFieldErrors, wideDialog = false, formId = "configForm", canDelete, deleteFunction }) {
    const [validated, setValidated] = useState(false);
    const { admin } = useContext(PrivilegesContext);

    // Id property needs to not exist to be a valid request
    if (dialogData.id === null) {
        delete dialogData.id;
    }

    const handleClose = () => {
        setFieldErrors({});
        setValidated(false);
        closeDialog();
    };

    const handleSave = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget;

        if (form.checkValidity() === true) {
            saveDialogData();
        }

        setValidated(true);
    };

    const handleDelete = () => {
        if (canDelete) {
            deleteFunction(dialogData)
                .then(_ => {
                    setFieldErrors({});
                    closeDialog();
                })
                .catch(error => {
                    setFieldErrors({
                        ...fieldErrors,
                        ...error.errors
                    });

                    for (const field in error.errors) {
                        let fieldDOM = document.querySelector("[name=" + field + "]");
                        fieldDOM.setCustomValidity(error.errors[field]);
                    }
                })
        }
    };

    const saveDialogData = () => {
        save(dialogData)
            .then(data => {
                setFieldErrors({});
                closeDialog();
            })
            .catch(error => {
                setFieldErrors({
                    ...fieldErrors,
                    ...error.errors
                });

                for (const field in error.errors) {
                    let fieldDOM = document.querySelector("[name=" + field + "]");
                    fieldDOM.setCustomValidity(error.errors[field]);
                }
            });
    };

    return (
        <>
            {showDialog &&
                <Modal dialogAs={DraggableModalDialog} className={wideDialog ? "wide-dialog" : ""} show={showDialog} onHide={handleClose} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form noValidate validated={validated} onSubmit={handleSave} id={formId}>
                            {children}
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        {canDelete &&
                            admin &&
                            !!dialogData.id &&
                            <Button variant="danger" onClick={handleDelete} className="me-auto">
                                Delete
                            </Button>
                        }
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" type="submit" form={formId}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
        </>
    );
}

export default CommonConfigDialog;